"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgFeather = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M10.291 3.305a7 7 0 0 1 9.417 0c.124.113.26.248.477.465l.045.045c.217.218.352.353.465.477a7 7 0 0 1 0 9.417.922.922 0 0 1-.686.291H11a1 1 0 1 0 0 2h5.483c.606 0 .909 0 1.049.12a.5.5 0 0 1 .174.42c-.015.183-.23.397-.657.826l-1.873 1.872-.036.037c-.134.134-.303.304-.51.43a2 2 0 0 1-.577.24 2.795 2.795 0 0 1-.665.055H6.568c-.252 0-.498 0-.706-.017a2.462 2.462 0 0 1-.374-.057l-2.78 2.781a1 1 0 0 1-1.415-1.414l2.78-2.78a2.472 2.472 0 0 1-.056-.375A9.185 9.185 0 0 1 4 17.432V10.612c0-.19-.001-.43.055-.665a2 2 0 0 1 .24-.578c.126-.206.296-.375.43-.509l.036-.036L9.815 3.77c.218-.217.353-.352.476-.465Z", fill: "currentColor" }) }))); };
exports.default = SvgFeather;
